import { Deserializable } from '../deserializable';

export class CaseTaskNameDto implements Deserializable {
  public Name: string;
  public Value: string;
  public Code: string;
  public Description: string;
  public AllocatedTo: string;
  public LetterTemplateName: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
